const STORAGE_KEY = 'notification_sound_muted';

export function isSoundMuted(): boolean {
  return localStorage.getItem(STORAGE_KEY) !== 'false';
}

export function setSoundMuted(muted: boolean): void {
  localStorage.setItem(STORAGE_KEY, String(muted));
  window.dispatchEvent(new CustomEvent('notification-sound-changed'));
}
